import { Http } from '@/lib/http';

export class CompanyService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/company-settings/company/';
  }

  createCompany(company) {
    return this.httpClient().post(`${this.endpoint}`, company);
  }

  fetchCompany() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  fetchCompanies() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateCompany(company) {
    return this.httpClient().patch(`${this.endpoint}${company.id}`, company);
  }

  deleteCompany(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }

  fetchCompanyApps() {
    return this.httpClient().get(`${this.endpoint}apps/`);
  }

  updateLogo(id, imageFile) {
    const formData = new FormData();
    formData.append('file', imageFile);
    return this.httpClient().patch(`${this.endpoint}file/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  removeLogo(id) {
    return this.httpClient().delete(`${this.endpoint}file/${id}`);
  }
}
